'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cruiTaskOverlay = require('@alicd/crui-task-overlay');

var _cruiTaskOverlay2 = _interopRequireDefault(_cruiTaskOverlay);

var _OrderNode = require('./OrderNode');

var _OrderNode2 = _interopRequireDefault(_OrderNode);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Setting = _cruiTaskOverlay2.default.Setting,
    Content = _cruiTaskOverlay2.default.Content,
    Footer = _cruiTaskOverlay2.default.Footer;

var TaskOrder = function (_React$Component) {
  (0, _inherits3.default)(TaskOrder, _React$Component);

  function TaskOrder(props, context) {
    (0, _classCallCheck3.default)(this, TaskOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskOrder.__proto__ || (0, _getPrototypeOf2.default)(TaskOrder)).call(this, props, context));

    _this.state = {
      dragNodesKeys: '',
      dragOverNodeKey: '',
      dropNodeKey: '',
      data: _this.props.dataSource
    };
    return _this;
  }

  (0, _createClass3.default)(TaskOrder, [{
    key: 'onDragStart',
    value: function onDragStart(e, treeNode) {
      this.dragNode = treeNode;
      this.dragNodesKeys = treeNode.props.eventKey;
      var st = {
        dragNodesKeys: this.dragNodesKeys
      };
      this.setState(st);
      this.props.onDragStart({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: 'onDragEnterGap',
    value: function onDragEnterGap(e, treeNode) {
      var offsetTop = (0, _utils.getOffset)(treeNode.refs.li).top;
      var offsetHeight = treeNode.refs.li.offsetHeight;
      var pageY = e.pageY;
      var gapHeight = 2;
      if (pageY > offsetTop + offsetHeight - gapHeight) {
        this.dropPosition = 1;
        return 1;
      }
      if (pageY < offsetTop + gapHeight) {
        this.dropPosition = -1;
        return -1;
      }
      this.dropPosition = 0;
      return 0;
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(e, treeNode) {
      var enterGap = this.onDragEnterGap(e, treeNode);
      if (this.dragNode.props.eventKey === treeNode.props.eventKey && enterGap === 0) {
        this.setState({
          dragOverNodeKey: ''
        });
        return;
      }
      var st = {
        dragOverNodeKey: treeNode.props.eventKey
      };

      this.setState(st);
      this.props.onDragEnter({
        event: e,
        node: treeNode
      });
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(e, treeNode) {
      this.props.onDragOver({ event: e, node: treeNode });
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(e, treeNode) {
      this.props.onDragLeave({ event: e, node: treeNode });
    }
  }, {
    key: 'onDrop',
    value: function onDrop(e, treeNode) {
      var key = treeNode.props.eventKey;
      var data = this.state.data;

      this.setState({
        dragOverNodeKey: '',
        dropNodeKey: key
      });
      if (this.dragNodesKeys === key) {
        return false;
      }

      var res = (0, _extends3.default)({
        event: e
      }, this.generateDropParams(treeNode));

      var direction = 'top';

      if (key > this.dragNodesKeys) {
        direction = 'bottom';
      } else {
        direction = 'top';
      }

      var newData = this.changePosition(data, this.dragNodesKeys, key, direction, res.dropPosition);

      this.setState({ data: newData });

      this.props.onDrop(res);
      this.props.onChange(newData);
    }
  }, {
    key: 'canDrop',
    value: function canDrop(treeNode) {
      var params = this.generateDropParams(treeNode);
      return this.props.canDrop(params);
    }
  }, {
    key: 'generateDropParams',
    value: function generateDropParams(treeNode) {
      return {
        dragNode: this.dragNode,
        dragNodesKeys: this.dragNodesKeys,
        node: treeNode,
        dropPosition: this.dropPosition,
        dropToGap: this.dropPosition !== 0
      };
    }
  }, {
    key: 'changePosition',
    value: function changePosition(arr, startIndex, toIndex, direction) {
      if (direction === 'down') {
        toIndex += toIndex;
      }
      var targetIndex = arr.splice(startIndex, 1)[0];
      arr.splice(toIndex, 0, targetIndex);
      return arr;
    }
  }, {
    key: 'deleteHandler',
    value: function deleteHandler(e, treeNode) {
      var _this2 = this;

      var value = treeNode.props.value;
      var data = this.state.data;
      data.forEach(function (item, i) {
        if (item.value === value) {
          data.splice(i, 1);
          _this2.setState({ data: data });
        }
      });

      this.props.onChange(data);
    }
  }, {
    key: 'cancelHandler',
    value: function cancelHandler() {
      // this.setState({visible: false});
      this.props.onCancel(this.state.data);
    }
  }, {
    key: 'okHandler',
    value: function okHandler(e) {
      // this.setState({visible: false});
      this.props.onOk(this.state.data);
      //this.props.onResult({e, result: this.state.data});
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      if (next.visible) {
        this.setState({ visible: next.visible });
      }

      if (next.dataSource) {
        this.setState({ data: next.dataSource });
      }
    }
  }, {
    key: '_getSetting',
    value: function _getSetting() {
      var _set = this._getChildrenByType(Setting);
      if (_set) {
        return _react2.default.createElement(
          Setting,
          null,
          _set
        );
      }
    }
  }, {
    key: '_getChildrenByType',
    value: function _getChildrenByType(type) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.children;

      if (type && children) {
        if (children.length > 1) {
          return children.filter(function (item) {
            return item.type === type;
          })[0];
        } else {
          return children.type === type ? children : null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = this.props;
      var state = this.state;
      var me = this;
      var _props = this.props,
          dialogConfig = _props.dialogConfig,
          onOk = _props.onOk,
          onCancel = _props.onCancel,
          showDelete = _props.showDelete,
          other = (0, _objectWithoutProperties3.default)(_props, ['dialogConfig', 'onOk', 'onCancel', 'showDelete']);

      var cloneProps = function cloneProps(key) {
        return {
          ref: 'order-' + key,
          root: me,
          eventKey: key,
          disabled: props.disabled,
          draggable: props.draggable,
          dragOver: state.dragOverNodeKey === key && me.dropPosition === 0,
          dragOverGapTop: state.dragOverNodeKey === key && me.dropPosition === -1,
          dragOverGapBottom: state.dragOverNodeKey === key && me.dropPosition === 1
        };
      };
      return _react2.default.createElement(
        _cruiTaskOverlay2.default,
        (0, _extends3.default)({}, other, {
          onCancel: this.cancelHandler.bind(this),
          onOk: this.okHandler.bind(this)
        }, dialogConfig),
        this._getSetting() || '',
        _react2.default.createElement(
          Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'cn-task-order' },
            _react2.default.createElement(
              'h3',
              { className: 'cn-task-order-title' },
              '\u6392\u5E8F\u8BBE\u7F6E'
            ),
            _react2.default.createElement(
              'ul',
              null,
              this.state.data.map(function (item, i) {
                var passProps = cloneProps(i);
                return _react2.default.createElement(_OrderNode2.default, (0, _extends3.default)({}, passProps, { showDelete: showDelete }, item, { key: i }));
              })
            )
          )
        )
      );
    }
  }]);
  return TaskOrder;
}(_react2.default.Component);

TaskOrder.propTypes = {
  dialogConfig: _propTypes2.default.object,
  dataSource: _propTypes2.default.array,
  onDragStart: _propTypes2.default.func,
  onDragEnter: _propTypes2.default.func,
  onDragOver: _propTypes2.default.func,
  onDragLeave: _propTypes2.default.func,
  onDrop: _propTypes2.default.func,
  canDrop: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  onOk: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onResult: _propTypes2.default.func,
  showDelete: _propTypes2.default.bool
};
TaskOrder.defaultProps = {
  dialogConfig: {},
  dataSource: [],
  align: 'cc cc',
  hasMask: true,
  width: 300,
  height: 500,
  title: '排序设置',
  showDelete: true,
  onDragStart: function onDragStart() {},
  onDragEnter: function onDragEnter() {},
  onDragOver: function onDragOver() {},
  onDragLeave: function onDragLeave() {},
  onDrop: function onDrop() {},

  canDrop: function canDrop() {
    return true;
  },
  onDelete: function onDelete() {},
  onCancel: function onCancel() {},
  onOk: function onOk() {},
  onChange: function onChange() {},
  onResult: function onResult() {}
};


TaskOrder.Setting = Setting;
TaskOrder.Content = Content;
TaskOrder.Footer = Footer;

exports.default = TaskOrder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-sorter@0.0.21@@alicd/crui-task-sorter/lib/TaskSorter.js
// module id = 718
// module chunks = 0